import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        cart: [],
        products: [],
        showCheckout: false,
        categories: [],
    },
    mutations: {
        updateCart (state, cart) {
            state.cart = cart
        },
        updateProducts (state, products) {
            state.products = products
        },
        updateCategories (state, categories) {
            state.categories = categories
        },
        showCheckout (state) {
            state.showCheckout = true
        },
        hideCheckout (state) {
            state.showCheckout = false
        },
    },
    getters: {
        products: state => state.products,
        categories: state => state.categories,
        showCheckout: state => state.showCheckout,
        cart: state => state.cart,
        itemsInCart: state => state.cart ? parseInt(state.cart.items_qty) : 0,
    },
    actions: {
        async getCartData ({ commit }) {
            await fetch('/api/checkout/cart')
                .then((response) => {
                    return response.json()
                })
                .then((data) => {
                    if (data.data) {
                        commit('updateCart', data.data)
                    } else {
                        commit('updateCart', [])
                    }
                    Promise.resolve()
                })
        },
        async getProducts ({ commit }) {
            fetch('/api/products?limit=999')
                .then((response) => {
                    return response.json()
                })
                .then((data) => {
                    const products = data.data.map(product => {
                        product.price = product.formated_price
                        product.image = product.base_image
                        product.orderableUntil = product.orderable_until
                        product.subtitle = product.description
                        return product
                    })
                    commit('updateProducts', products)
                    Promise.resolve()
                })
        },
        async getCategories ({ commit }) {
            fetch('/api/categories')
                .then((response) => {
                    return response.json()
                })
                .then((data) => {
                    const categories = data.data.map(category => {
                        // product.price = product.formated_price
                        // product.image = product.base_image
                        return category
                    })
                    commit('updateCategories', categories)
                })
        },
        async addToCard ({ dispatch, commit }, data) {
            await fetch('/api/checkout/cart/add', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  product_id: data.id,
                  quantity: data.quantity,
                  is_configurable: false,
                }),
              })
                .then((response) => {
                  return response.json()
                }).then(() => {
                    dispatch('getCartData').then(() => {
                        Promise.resolve()
                    })
                })
        },
        async removeFromCard ({ dispatch, commit }, id) {
            await fetch('/api/checkout/cart/remove-item/' + id, {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                },
              })
                .then((response) => {
                  return response.json()
                }).then(() => {
                    dispatch('getCartData').then(() => {
                        Promise.resolve()
                    })
                })
        },
    },
})
